// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from email-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function EmailFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M.031 3.647 7.7 9.4l.08.049a.5.5 0 0 0 .44 0L8.3 9.4l7.67-5.752.022.174L16 4v8a2 2 0 0 1-1.85 1.995L14 14H2a2 2 0 0 1-1.995-1.85L0 12V4c0-.12.01-.238.031-.353ZM14 2c.618 0 1.17.28 1.538.721L8 8.375.462 2.721c.33-.397.811-.663 1.355-.713L2 2h12Z"
      />
    </svg>
  );
}
